export const extractKeyFromUrl = (url) => {
  try {
    if (!url) return null;

    if (!/^https?:\/\//i.test(url)) {
      return url;
    }

    const parsed = new URL(url);
    return parsed.pathname.replace(/^\/+/, "");
  } catch (e) {
    console.error("Failed to extract key from url:", url, e);
    return url;
  }
};
